import { useState, useEffect, useMemo, useRef } from "react";
import SelectStaff from "../../../elements/selectStaff";
import { getTrackHoldShop, exportAnalyticShop } from "actions/analyticActions";
import { connect } from "react-redux";
import useCallApiUrl from "hook/useCallApiUrl";
import useCallApi from "hook/useCallApi";
import Loading from "components/Loading";
import { ReactTableDataGrid } from "components/Table";
import { getSizePerPageList } from "helper/constant";
import { formatterCreateAt, FormatterMoney } from "components/Function";
import TrackPayout from "./trackPayout";
import OverviewConnect from "./overview";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { CSVLink } from "react-csv";

const ShopAnalytic = ({ formatterCreateAt, getTrackHoldShop, exportAnalyticShop }) => {
    const { t } = useTranslation();
    const [filter, setFilter] = useState({});
    const searchOptions = useMemo(() => {
        return { filter };
    }, [filter]);
    const { data, loading } = useCallApiUrl("/api/analytic/shop", filter);
    const { data: dataTrackHold } = useCallApi(getTrackHoldShop, searchOptions);
    const btnRef = useRef(null);
    const [export_shop_analytic_data, setExportShopAnalyticData] = useState([]);
    const [initiateDownload, setInitiateDownload] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const shop_status = [
        { value: "active", label: t("Active") },
        { value: "die", label: t("Die") },
    ];

    const defaultColDef = useMemo(
        () => ({
            wrapText: true,
            autoHeight: true,
            autoHeaderHeight: true,
        }),
        []
    );

    useEffect(() => {
        setInitiateDownload(false);
        if (initiateDownload) {
            btnRef.current?.click();
        }
    }, [initiateDownload]);

    const onClicExportShopAnalytic = async () => {
        setIsLoading(true);
        const { data: export_shop_analytic_data_tmp } = await exportAnalyticShop(searchOptions);

        if (export_shop_analytic_data_tmp && export_shop_analytic_data_tmp.length > 0) {
            var export_shop_analytic_data = [];
            for (var i = 0; i < export_shop_analytic_data_tmp.length; i++) {
                var export_shop_analytic_data_ea = {
                    "Shop Info": export_shop_analytic_data_tmp[i]?.name || "",
                    "Shop Status": export_shop_analytic_data_tmp[i]?.member_note === "The seller is inactive." ? "Die" : "Active",
                    "Note": `${export_shop_analytic_data_tmp[i]?.note} - ${export_shop_analytic_data_tmp[i]?.member_note}`,
                    "Member": export_shop_analytic_data_tmp[i]?.members?.[0]?.email,
                    "Total Products": export_shop_analytic_data_tmp[i]?.productCount,
                    "Total Orders": export_shop_analytic_data_tmp[i]?.orderCount,
                    "Last Sale": formatterCreateAt(export_shop_analytic_data_tmp[i]?.lastSale * 1000, "full", "Asia/Ho_Chi_Minh"),
                    "Est. Payout": export_shop_analytic_data_tmp[i]?.estimated_settlement,
                    "Total Hold": FormatterMoney({ money: export_shop_analytic_data_tmp[i]?.sum_est_settlement_amount, currency: export_shop_analytic_data_tmp[i]?.region, currency_to: "USD", type: "number" }),
                    "Total Net Earning": FormatterMoney({ money: export_shop_analytic_data_tmp[i]?.sum_net_earning, currency: export_shop_analytic_data_tmp[i]?.region, currency_to: "USD", type: "number" }),
                    "Orders Today": export_shop_analytic_data_tmp[i]?.todayOrderCount,
                    "Orders last 3 days": export_shop_analytic_data_tmp[i]?.last3DayOrderCount,
                    "Orders last 7 days": export_shop_analytic_data_tmp[i]?.last7DayOrderCount,
                    "Orders last 30 days": export_shop_analytic_data_tmp[i]?.last30DayOrderCount,
                    "Wait Shipment / Collection": `'${export_shop_analytic_data_tmp[i]?.awaitingShipmentCount} / ${export_shop_analytic_data_tmp[i]?.awaitingCollectionCount}`,
                    "In Transit / Delivered": `'${export_shop_analytic_data_tmp[i]?.inTransitCount} / ${export_shop_analytic_data_tmp[i]?.deliveredCount}`,
                    "Completed / Cancelled": `'${export_shop_analytic_data_tmp[i]?.completedCount} / ${export_shop_analytic_data_tmp[i]?.cancelledCount}`,
                }
                export_shop_analytic_data.push(export_shop_analytic_data_ea);
            }
            setExportShopAnalyticData(export_shop_analytic_data);
            setInitiateDownload(true);
        }
        setIsLoading(false);
    }

    const groupButton = () => {
        return (
            <>
                <div className="mb-5">
                    <button type="button" onClick={onClicExportShopAnalytic} className="btn btn-success btn-sm me-2 mb-2">
                        <i className="fa fa-file-excel-o fs-2"></i> Export
                    </button>
                    <CSVLink filename={"analytic_shops_" + formatterCreateAt((new Date()).getTime(), "dmy", "Asia/Ho_Chi_Minh") + ".csv"} data={export_shop_analytic_data}>
                        <span ref={btnRef} />
                    </CSVLink>
                </div>
            </>
        );
    };

    const columns = [
        {
            field: "_id",
            width: 30,
            cellClass: "centered-cell",
            headerName: "",
            cellRenderer: ({ rowIndex, value: cell, data: row }) => rowIndex + 1,
        },
        {
            field: "shopInfo",
            cellClass: "centered-cell",
            headerName: "Shop Info",
            cellRenderer: ({ rowIndex, value: cell, data: row }) => (
                <div>
                    {row.name}
                </div>
            ),
            comparator: (_cellA, _cellB, { data: valueA }, { data: valueB }) => {
                if (valueA?.name < valueB?.name) return -1;
                if (valueA?.name > valueB?.name) return 1;
                return 0;
            },
        },
        {
            field: "noteInfo",
            cellClass: "centered-cell",
            headerName: "Note",
            cellRenderer: ({ rowIndex, value: cell, data: row }) => (
                <div>
                    {row.note} - {row.member_note}
                </div>
            ),
            comparator: (_cellA, _cellB, { data: valueA }, { data: valueB }) => {
                if (valueA?.name < valueB?.name) return -1;
                if (valueA?.name > valueB?.name) return 1;
                return 0;
            },
        },
        {
            field: "members",
            cellClass: "centered-cell",
            headerName: "Member",
            cellRenderer: ({ rowIndex, value: cell, data: row }) => (
                <div>
                    {cell?.[0]?.email || ""}
                </div>
            ),
        },
        {
            field: "productCount",
            cellClass: "centered-cell",
            headerName: "Total Products",
        },
        {
            field: "orderCount",
            cellClass: "centered-cell",
            headerName: "Total Orders",
        },
        {
            field: "lastSale",
            cellClass: "centered-cell",
            headerName: "Last Sale",
            cellRenderer: ({ value: cell }) => (
                <span data-tooltip-id="my-tooltip" data-tooltip-content={formatterCreateAt(cell)}>
                    {formatterCreateAt(cell * 1000)}
                </span>
            ),
        },
        {
            field: "estimated_settlement",
            headerName: "Est. Payout",
            sortable: false,
            cellRenderer: ({ rowIndex, value: cell, data: row }) => cell,
        },
        {
            field: "sum_est_settlement_amount",
            headerName: "Total Hold",
            cellRenderer: ({ rowIndex, value: cell, data: row }) => <FormatterMoney money={cell} currency={row.region} currency_to={"US"} />,
        },
        {
            field: "sum_net_earning",
            headerName: "Total Net Earning",
            cellRenderer: ({ rowIndex, value: cell, data: row }) => <FormatterMoney money={cell} currency={row.region} currency_to={"US"} />,
        },
        {
            field: "todayOrderCount",
            headerName: "Orders Today",
            cellClass: "cell-full-height",
        },
        {
            field: "last3DayOrderCount",
            headerName: "Orders last 3 days",
            cellClass: "cell-full-height",
        },
        {
            field: "last7DayOrderCount",
            headerName: "Orders last 7 days",
            cellClass: "cell-full-height",
        },
        {
            field: "last30DayOrderCount",
            headerName: "Orders last 30 days",
            cellClass: "cell-full-height",
        },
        {
            field: "awaitingShipmentCount",
            headerName: "Wait Shipment / Collection",
            cellClass: "cell-full-height",
            cellRenderer: ({ rowIndex, value: cell, data: row }) => `${cell} / ${row.awaitingCollectionCount}`,
        },
        {
            field: "inTransitCount",
            headerName: "In Transit / Delivered",
            cellClass: "cell-full-height",
            cellRenderer: ({ rowIndex, value: cell, data: row }) => `${cell} / ${row.deliveredCount}`,
        },
        {
            field: "completedCount",
            headerName: "Completed / Cancelled",
            cellClass: "cell-full-height",
            cellRenderer: ({ rowIndex, value: cell, data: row }) => `${cell} / ${row.cancelledCount}`,
        },
    ];

    return (
        <div className="d-flex flex-column gap-6" style={{ margin: "auto" }}>
            <Loading isLoading={isLoading || loading} />
            <OverviewConnect />
            <div className="d-flex gap-2 mb-4">
                <SelectStaff onChange={(data) => {
                    setFilter((prev) => {
                        if (data) {
                            return { ...prev, staff: data };
                        }

                        const { staff, ...rest } = prev;
                        return rest;
                    });
                }} />
                <Select
                    isClearable
                    name="shop_status"
                    options={shop_status}
                    value={shop_status.filter(({ value }) => value === filter?.shop_status)}
                    className="basic-multi-select al-custom-select-search-variants al-filter-table"
                    classNamePrefix="select"
                    onChange={(data) => {
                        setFilter((prev) => {
                            if (data?.value) {
                                return { ...prev, shop_status: data?.value };
                            }

                            const { shop_status, ...rest } = prev;
                            return rest;
                        });
                    }}
                    placeholder={t(`Select a shop status ... `)}
                />
            </div>
            <div className="mb-4">
                <TrackPayout data={dataTrackHold} />
            </div>
            <div className="card card-body">
                <h3>Analytic</h3>
                <ReactTableDataGrid
                    tableName="analyticShopTableShopsCR"
                    idProperty="_id"
                    height={350}
                    columns={columns}
                    rowData={data?.data || []}
                    defaultColDef={defaultColDef}
                    gridOptions={{
                        reactiveCustomComponents: true,
                    }}
                    totalSize={data?.total || 0}
                    paginationPageSize={filter.limit || 10}
                    emptyText={"No data!"}
                    rowSelection="multiple"
                    sizePerPageList={getSizePerPageList(data?.total)}
                    onTableChanged={(data) => {
                        setFilter((prev) => ({
                            ...prev,
                            offset: data.page - 1 ?? prev.page,
                            limit: (data.limit ?? prev.limit) || 10,
                            search: data.text ?? prev.text,
                        }));
                    }}
                    groupButton={groupButton}
                // isSearchText={false}
                />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({});
const mapDispatchToProps = { formatterCreateAt, getTrackHoldShop, exportAnalyticShop };

export default connect(mapStateToProps, mapDispatchToProps)(ShopAnalytic);
